import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=43d0ae50&"
import script from "./Wrap.vue?vue&type=script&lang=ts&"
export * from "./Wrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d0ae50')) {
      api.createRecord('43d0ae50', component.options)
    } else {
      api.reload('43d0ae50', component.options)
    }
    module.hot.accept("./Wrap.vue?vue&type=template&id=43d0ae50&", function () {
      api.rerender('43d0ae50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Wrap.vue"
export default component.exports